import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { MVKMapContainer } from '../../containers/map';
import { FlatPhaseContainer } from '../../containers/flat_phase';
import { FloorSchemeContainer } from '../../containers/floor_scheme';
import { InfoTooltipContainer } from '../../containers/info_tooltip';
import { FullscreenButton } from '../map/Controls/FullscreenButton';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MainBlock = /*#__PURE__*/function (_React$Component) {
  _inherits(MainBlock, _React$Component);
  var _super = _createSuper(MainBlock);
  function MainBlock() {
    var _this;
    _classCallCheck(this, MainBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "fullScreenTimer", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      shouldShowFullScreenTip: false
    });
    _defineProperty(_assertThisInitialized(_this), "showFullscreenTip", function () {
      if (!window) {
        return;
      }
      var changeFullScreenTipVisibility = _this.props.changeFullScreenTipVisibility;
      changeFullScreenTipVisibility(true);
      _this.fullScreenTimer = window.setTimeout(function () {
        changeFullScreenTipVisibility(false);
      }, 5000);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleFullScreen", function () {
      clearTimeout(_this.fullScreenTimer);
      _this.props.toggleFullScreen(!_this.props.isFullScreen);
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (event) {
      var isFullScreen = _this.props.isFullScreen;
      if (event.keyCode === 27 && isFullScreen) {
        _this.props.toggleFullScreen(!isFullScreen);
      }
    });
    return _this;
  }
  _createClass(MainBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeydown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.fullScreenTimer);
      document.removeEventListener('keydown', this.handleKeydown, false);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this.props.isFullScreen && nextProps.isFullScreen) {
        this.showFullscreenTip();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isFullScreen = _this$props.isFullScreen,
        isOfferCard = _this$props.isOfferCard,
        isPanoramaActive = _this$props.isPanoramaActive;
      return /*#__PURE__*/_jsxs("div", {
        className: styles['container'],
        id: "newbuilding_mvk_fragment-main_block",
        children: [!isOfferCard && !isPanoramaActive && /*#__PURE__*/_jsx(FullscreenButton, {
          onToggle: this.toggleFullScreen,
          isActive: isFullScreen
        }), /*#__PURE__*/_jsx(InfoTooltipContainer, {}), /*#__PURE__*/_jsx(MVKMapContainer, {}), /*#__PURE__*/_jsx(FloorSchemeContainer, {}), /*#__PURE__*/_jsx(FlatPhaseContainer, {})]
      });
    }
  }]);
  return MainBlock;
}(React.Component);